import gsap from 'gsap'
import ContactsComponent from './contacts.js'

export default class ContactsformoverlayComponent extends ContactsComponent {
  constructor (el) {
    super(el)
    this.data = {
      errors: []
    }
  }

  init () {
    this.formSetup()
    document.addEventListener('contactformoverlay.toggle', () => this.toggle())
    document.addEventListener('click', e => {
      if (e.target.closest('.cm-contactformoverlay-close')) {
        this.toggle()
      }
    })
  }

  toggle () {
    const header = document.getElementById('head')

    if (this.el.classList.contains('cm-contactformoverlay--active')) {
      this.el.classList.remove('cm-contactformoverlay--active')
      if (header) {
        gsap.to(header, { autoAlpha: 1, duration: 0.3 })
      }
    } else {
      this.el.classList.add('cm-contactformoverlay--active')
      if (header) {
        gsap.to(header, { autoAlpha: 0, duration: 0.3 })
      }
    }
  }
}
